// extracted by mini-css-extract-plugin
module.exports = {"Icon":"PokemonMarker_Icon__32Sbw","Good":"PokemonMarker_Good__2FO2t","Great":"PokemonMarker_Great__xk2no","Best":"PokemonMarker_Best__20jM4","Label":"PokemonMarker_Label__1f6DG"};